import { ValidationResult, ValidatorOptions } from './types.validators';

export abstract class Validator {
    public abstract validate(value: string, options: ValidatorOptions): ValidationResult;
}
